import { mapGetters} from "vuex";

export default {
  name: 'timeout',
  props: {
    appId: {
      type: String
    }
  },
  data () {
    return {
      brandingName: localStorage.getItem('branding') || 'jimber',
      returnUrl: '',
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }
  },
  mounted () {
    console.log(this.vaultImagePath)
    console.log(this.$route.params)
  },
  computed: {
    ...mapGetters(['vaultImagePath']),
    getReturnUrl () {
      const singleVaultInvitationLink = window.localStorage.getItem('singleVaultInvitationUrl')

      if (singleVaultInvitationLink != null && singleVaultInvitationLink !== '') {
        return singleVaultInvitationLink
      } else {
        return `https://${this.$route.params.appId}`
      }
    }
  }
}
